// extracted by mini-css-extract-plugin
module.exports = {"paragraphs":"AppParagraphs_paragraphs____EfG","selling-hours":"AppParagraphs_selling-hours__9FmBQ"};